import { useState } from "react";
import axios from "axios";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

const PayPalCheckout = () => {
  const { items, clear, setOpen } = useCart();
  const [busy, setBusy] = useState(false);

  if (!CLIENT_ID) return null;

  const createOrder = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/payments/paypal/create-order`, {
        items: items.map((i) => ({ lookup_key: i.lookup_key, quantity: i.qty, color: i.color })),
        origin_url: window.location.origin,
      });
      return data.order_id;
    } catch (e) {
      toast.error("PayPal could not be started. Please try the card checkout.");
      setBusy(false);
      throw e;
    }
  };

  const onApprove = async (data) => {
    try {
      await axios.post(`${API}/payments/paypal/capture-order`, { order_id: data.orderID });
      clear();
      setOpen(false);
      window.location.href = `/payment/paypal-success?order_id=${data.orderID}`;
    } catch (e) {
      toast.error("Payment could not be confirmed. Please contact support.");
      setBusy(false);
    }
  };

  return (
    <div data-testid="paypal-checkout" className={busy ? "opacity-70 pointer-events-none" : ""}>
      <div className="flex items-center gap-3 my-4">
        <div className="h-px flex-1 bg-taupe/40" />
        <span className="text-[10px] tracking-[0.25em] uppercase text-charcoal/40">or pay with</span>
        <div className="h-px flex-1 bg-taupe/40" />
      </div>
      <PayPalScriptProvider options={{ clientId: CLIENT_ID, currency: "AUD", intent: "capture" }}>
        <PayPalButtons
          style={{ layout: "horizontal", color: "gold", shape: "pill", label: "paypal", height: 45 }}
          createOrder={createOrder}
          onApprove={onApprove}
          onError={() => {
            toast.error("PayPal checkout failed. Please try the card checkout.");
            setBusy(false);
          }}
          onCancel={() => setBusy(false)}
        />
      </PayPalScriptProvider>
    </div>
  );
};

export default PayPalCheckout;
